import React from 'react';
import Carousel from '../components/Carousel';
import "./css/Gallery.css"

import gallery from "../img/C block/С Блок.png"
import gallery1 from '../img/C block/0-02-08-040ba7ff059e7f29a25d0bcfbf95b7659cea67d44060aed3415c3af02988f073_43e6790c1ad09d86.jpg';
import gallery2 from '../img/C block/0-02-08-53ba31ae55444cefca778481ce5b323f6c38fc6f22aeee8f5c8002716fd92d1c_f488a28714dcea26.jpg';
import gallery3 from '../img/C block/0-02-08-568984691a11f653034d69841389f558eae4e0a956c80cfdf0f556ace3affe56_193d4d8db4f8486f.jpg';


const galleryItems = [
    {
        id: 1,
        type: 'image' as const,
        src: gallery || 'https://via.placeholder.com/1920x1080/2c4a63/ffffff?text=Gallery+2',
        alt: 'Floor image 1',

    },
    {
        id: 2,
        type: 'image' as const,
        src: gallery1 || 'https://via.placeholder.com/1920x1080/2c4a63/ffffff?text=Gallery+2',
        alt: 'Floor image 1',

    },

    {
        id: 3,
        type: 'image' as const,
        src: gallery2 || 'https://placehold.co/600x400',
        alt: 'Gallery Image 1',

    },
    {
        id: 4,
        type: 'image' as const,
        src: gallery3 || 'https://via.placeholder.com/1920x1080/2c4a63/ffffff?text=Gallery+2',
        alt: 'Gallery Image 2',

    },


];

const Gallery3: React.FC = () => {
    return (
        <div className="gallery-page">
            <Carousel
                items={galleryItems}
                autoPlay={true}
                autoPlayInterval={6000}
            />
        </div>
    );
};

export default Gallery3;